export default __webpack_public_path__ + "static/media/gallery-wip-emitter_01.373f6664.jpg";